/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const e=["web-gltf","web","cim"];export{e as defaultAcceptedFormats};
